import { Component } from '@angular/core';

@Component({
  selector: 'app-kes-thankyou',
  templateUrl: './kes-thankyou.component.html',
  styleUrls: ['./kes-thankyou.component.css']
})
export class KesThankyouComponent {

}
